import { type AxiosInstance } from 'axios';

type RequestListener = Record<string, { pending: number }>;

const requestListeners: RequestListener = {};

type WatchParams = {
  instance: AxiosInstance;
  urlMatch: string;
};

export const addRequestListener = ({ instance, urlMatch }: WatchParams) => {
  instance.interceptors.request.use(
    (request) => {
      const url = request.url;
      if (!url || !urlMatch) return request;
      if (urlMatch !== url) return request;

      if (!requestListeners[url]) requestListeners[url] = { pending: 0 };
      requestListeners[url].pending += 1;
      return request;
    },
    (error) => Promise.reject(error),
  );

  instance.interceptors.response.use(
    (response) => {
      const url = response.config.url;
      if (!url || !urlMatch) return response;
      if (urlMatch !== url) return response;

      if (requestListeners[url]) requestListeners[url].pending -= 1;
      return response;
    },
    (error) => {
      const url = error.config.url;
      if (requestListeners[url]) requestListeners[url].pending -= 1;
      return Promise.reject(error);
    },
  );
};

export const clearPendingRequests = (url: string): void => {
  requestListeners[url] = { pending: 0 };
};

export const hasPendingRequests = (url: string): boolean => requestListeners[url]?.pending > 0;
